import React, { Component } from 'react';

import { connect } from 'react-redux';


// import { openModal } from '../modals/modalActions'

const mapState = state => ({
    data: state.test.data,
    loading: state.test.loading
});


const actions = {
    // incrementAsync,
    // decrementAsync,
    // openModal
};

// const Marker = () => <Icon name='marker' size='big' color='red'/>

class TestComponent extends Component {
    render() {
        const inputProps = {
            // value: this.state.address,
            // onChange: this.onChange
        };

        const { data } = this.props;
        return (
            <div>
                <h1>Test Area</h1>
                <h3>The answer is: {data}</h3>

            </div>
        );
    }
}

export default connect(mapState)(TestComponent);



// WEBPACK FOOTER //
// ./src/Components/testarea/TestComponent.jsx